import { DEFAULT_PROVINCE_CODE } from '../constants';
import { useProvinces, useUserOrDefaultProvince } from '../sitecoreContext';
/**
 * Get the price flags for the current province
 */
const usePriceFlagsForProvince = () => {
    var _a;
    const provinces = useProvinces();
    const provinceCode = useUserOrDefaultProvince() || DEFAULT_PROVINCE_CODE;
    const province = Array.isArray(provinces) && provinces.length
        ? provinces === null || provinces === void 0 ? void 0 : provinces.find(p => { var _a; return ((_a = p === null || p === void 0 ? void 0 : p.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (provinceCode === null || provinceCode === void 0 ? void 0 : provinceCode.toLowerCase()); })
        : undefined;
    const showSellingPrice = (_a = province === null || province === void 0 ? void 0 : province.showSellingPrice) !== null && _a !== void 0 ? _a : true;
    return {
        showMsrpPrice: !showSellingPrice,
        showSellingPrice,
    };
};
export default usePriceFlagsForProvince;
